import { useEffect, useState } from 'react';
import { LoginForm } from './LoginForm';
import { AdminShell } from './AdminShell';
import './admin.css';

type State = { status: 'loading' } | { status: 'anon' } | { status: 'authed'; email: string };

export function AdminApp() {
  const [state, setState] = useState<State>({ status: 'loading' });
  const error = new URLSearchParams(window.location.search).get('error') || undefined;

  useEffect(() => {
    let alive = true;
    fetch('/api/auth/me', { headers: { Accept: 'application/json' } })
      .then((r) => r.json() as Promise<{ authed: boolean; email?: string }>)
      .then((d) => {
        if (!alive) return;
        setState(d.authed && d.email ? { status: 'authed', email: d.email } : { status: 'anon' });
      })
      .catch(() => alive && setState({ status: 'anon' }));
    return () => {
      alive = false;
    };
  }, []);

  // Signed in → the full-screen SaaS dashboard.
  if (state.status === 'authed') return <AdminShell email={state.email} />;

  // Signed out / loading → the centered login card.
  return (
    <main className="adminpage">
      <a className="admin-back" href="/">
        <span aria-hidden="true">&larr;</span> Back to home
      </a>
      {state.status === 'loading' && <div className="admin-spinner" aria-label="loading" />}
      {state.status === 'anon' && <LoginForm initialError={error} />}
    </main>
  );
}
